import { STYLE_AJOUT } from './marque-ajout';
import { STYLE_CHANGEMENT } from './marque-changement';
import { MarqueInvariant } from './marque-invariant';
import { MarquePassage } from './marque-passage';

interface LegendeMarquesProps {
  /** The invariants are marked in the texts (the analysis found some): the keys strict and flexible. */
  avecInvariants: boolean;
  /** An addition of the control is marked in the translated text (#23): its key. */
  avecAjouts?: boolean;
  /** A change the translation declares is marked in the translated text (#28): its key. */
  avecChangements?: boolean;
  /** A passage a "Bloquant" point of another indicator is about is marked ("Texte traduit"): its key. */
  avecPassages?: boolean;
}

/**
 * The key of the marks of "Avant / après", above the two texts (#30; it was under the list of
 * the invariants): "strict reproduit tel quel", "souple adapté, sens conservé", then the key of
 * the additions ("ajout") and the one of the changes ("changement") when they are marked: one
 * word each, no status, no "declared by the translation" (decision of 2026-10-13). The keys are
 * the marks themselves, with the same look as in the texts. Nothing marked, nothing shown. The
 * legend is the same component in "Avant / après" and in "Texte traduit" (#35), above the text; the
 * key of a passage the control blocks on ("passage signalé par le contrôle") is only there.
 */
export function LegendeMarques({
  avecInvariants,
  avecAjouts = false,
  avecChangements = false,
  avecPassages = false,
}: LegendeMarquesProps) {
  if (!avecInvariants && !avecAjouts && !avecChangements && !avecPassages) return null;
  return (
    <section
      aria-label="légende des marques"
      className="rounded-md border border-gray-200 px-6 py-3"
    >
      <p className="flex flex-wrap gap-x-4 gap-y-1 text-caption text-gray-700 leading-[1.7]">
        {avecInvariants ? (
          <>
            <span>
              <MarqueInvariant verrou="strict">strict</MarqueInvariant> reproduit tel quel
            </span>
            <span>
              <MarqueInvariant verrou="souple">souple</MarqueInvariant> adapté, sens conservé
            </span>
          </>
        ) : null}
        {avecAjouts ? (
          <span>
            <mark className={STYLE_AJOUT}>ajout</mark>
          </span>
        ) : null}
        {avecPassages ? (
          <span>
            <MarquePassage>passage</MarquePassage> signalé par le contrôle
          </span>
        ) : null}
        {avecChangements ? (
          <span>
            <mark className={STYLE_CHANGEMENT}>changement</mark>
          </span>
        ) : null}
      </p>
    </section>
  );
}
